import { appUrl } from 'utils/wrappers';

import Base from 'app/models/base';

export default Base.extend({
  url() {
    return appUrl(`users/${this.user.id}/brand`);
  },

  initialize ({ user }) {
    this.user = user;
  },

  isNew() {
    return !this.has('object'); // Makes model.save perform a PUT vs POST. Brands don't have IDs
  },

  toJSON(options = {}) {
    const { name, color, logo, logo_href, ad, ad_href } = this.attributes;
    const json = { name, color, logo_href, ad_href };
    if (options.includeHrefs || (logo && logo.startsWith('data:image/'))) json.logo = logo;
    if (options.includeHrefs || (ad && ad.startsWith('data:image/'))) json.ad = ad;
    return json;
  },
});



// WEBPACK FOOTER //
// ./app/models/brand.js